const CreditCardIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M2.25 9.08398H21.75V17.9996C21.75 18.1985 21.671 18.3893 21.5303 18.5299C21.3897 18.6706 21.1989 18.7496 21 18.7496H3C2.80109 18.7496 2.61032 18.6706 2.46967 18.5299C2.32902 18.3893 2.25 18.1985 2.25 17.9996V9.08398Z'
                fill='#827CA8'
            />
            <path
                d='M21 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6V18C2.25 18.4142 2.58579 18.75 3 18.75H21C21.4142 18.75 21.75 18.4142 21.75 18V6C21.75 5.58579 21.4142 5.25 21 5.25Z'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.75 15.75H18.75'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.25 15.75H12.75'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.25 9.08398H21.75'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default CreditCardIcon;
